// src/api/axiosInstance.js
import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

if (!baseURL) {
  console.warn('⚠️ No REACT_APP_BACKEND_URL set — requests will fail!');
}

const instance = axios.create({ baseURL });

// ✅ Inject token if available
instance.interceptors.request.use((config) => {
  const raw = localStorage.getItem('daisy-user');
  console.log('📦 Interceptor localStorage contents:', raw);

  let user = null;
  try {
    user = JSON.parse(raw);
  } catch (err) {
    console.warn('⚠️ Failed to parse user from localStorage:', err);
  }

  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
    console.log('🔐 Token attached to request:', user.token);
  }

  return config;
});

export default instance;

